import Banner from "./components/Banner";
import General from "./components/General";
import Notification from "./components/Notification";
import Project from "./components/Project";
import Storage from "./components/Storage";
import Upload from "./components/Upload";
import useAsyncEffect from "use-async-effect";
import {useState} from "react";
import axios from "axios";
import {useUserAuth} from "../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import UserDevicesSummary from "./components/UserDevicesSummary";
import UserAppNotifications from "./components/UserAppNotifications";
import Password from "./components/Password";
import DeleteAccount from "./components/DeleteAccount";

const ProfileOverview = () => {

        return (
            <div>
                {
                    <div className="flex w-full flex-col gap-5">

                        <div className="w-ful mt-3 flex h-fit flex-col gap-5 lg:grid lg:grid-cols-12">
                            <div className="col-span-4 lg:!mb-0">
                                <Banner/>
                            </div>

                            <div className="col-span-3 lg:!mb-0">
                                <Password/>
                            </div>

                            <div className="z-0 col-span-5 lg:!mb-0">
                                <Upload/>
                            </div>
                        </div>

                        <div className="grid h-full grid-cols-1 gap-5 lg:!grid-cols-12">
                            <div className="col-span-5 lg:col-span-12 lg:mb-0 3xl:col-span-4">
                                <UserDevicesSummary/>
                            </div>
                            <div className="col-span-5 lg:col-span-12 lg:mb-0 3xl:!col-span-4">
                                <UserAppNotifications/>
                            </div>
                            <div className="col-span-5 lg:col-span-12 lg:mb-0 3xl:col-span-4">
                                <General/>
                            </div>

                        </div>

                        <DeleteAccount/>
                    </div>
                }
            </div>
        );
    }
;

export default ProfileOverview;
